// The tenant id will be saved in the session storage
import { getCookie, setCookie } from '../utils/cookies';
import { teamIdCookie } from '../types/authenticationContext.types';
export const tenantIdKey = 'tenantId';
export const getTenantId = () => {
    const sessionTenantId = window.sessionStorage.getItem(tenantIdKey);
    const localTenantId = window.localStorage.getItem(tenantIdKey);
    if (localTenantId) {
        setTenantId(localTenantId);
        return localTenantId;
    }
    if (sessionTenantId) {
        setTenantId(sessionTenantId);
        return sessionTenantId;
    }
    return null;
};
export const setTenantId = (tenantId) => {
    window.sessionStorage.setItem(tenantIdKey, tenantId);
    window.localStorage.setItem(tenantIdKey, tenantId);
};
export const setTenantIdCookie = (tenantId, minutes) => {
    setCookie(teamIdCookie, tenantId, minutes || 1440);
};
export const getTenantIdCookie = () => {
    return getCookie(teamIdCookie);
};
export const setTenantIdAllStorages = (tenantId, minutes) => {
    setTenantId(tenantId);
    setTenantIdCookie(tenantId, minutes);
};
